module.exports = __webpack_public_path__ + "img/ga.b7f7544b.svg";